import { ArrowUpRight, BadgeCheck } from "lucide-react";
import Reveal from "./Reveal";
import { BRAND, PRACTITIONER } from "@/config/clinicConfig";

const PORTRAIT_IMAGE =
  "https://customer-assets-jai6qajn.emergentagent.net/job_instant-site-151/artifacts/3cgg6yu4_20230725_121415.webp";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="pt-10 pb-24 lg:pt-14 lg:pb-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="float-left relative mb-8 mr-8 w-1/2 sm:w-[44%] lg:mb-12 lg:mr-14 lg:w-[38%]">
          <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_80px_-40px_rgba(44,34,30,0.5)]">
            <img
              src={PORTRAIT_IMAGE}
              alt="Sherry Corvino, laser eyeliner and cosmetic tattoo removal expert"
              className="aspect-[4/4.2] w-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-10 -right-6 rounded-2xl bg-espresso px-4 py-3 text-cream shadow-xl sm:-bottom-12 sm:-right-10">
            <p className="font-display text-xl font-semibold text-gold sm:text-2xl">90%</p>
            <p className="max-w-[8.5rem] text-[11px] leading-snug opacity-90">
              of Sherry's clients travel from outside the state for treatment
            </p>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <h2 className="font-display text-3xl font-medium leading-snug tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
              {PRACTITIONER.heading}
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-base leading-relaxed text-cocoa sm:text-lg">
              {PRACTITIONER.bio.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <p className="mt-6 font-display text-xl italic text-espresso">
              — {PRACTITIONER.name}, {PRACTITIONER.credentials}
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {PRACTITIONER.credentialsChips.map((c) => (
                <li
                  key={c}
                  className="flex items-start gap-2.5 rounded-xl border border-espresso/10 bg-card/70 px-4 py-3 text-[13.5px] font-medium text-espresso"
                >
                  <BadgeCheck size={16} className="mt-0.5 shrink-0 text-clay" />
                  {c}
                </li>
              ))}
            </ul>
            <a
              data-testid="about-cta"
              href={BRAND.consultUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-9 inline-flex items-center gap-2 text-sm font-semibold text-clay"
            >
              Discuss your eyeliner with {PRACTITIONER.name.split(",")[0]}
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:rotate-45" />
            </a>
          </Reveal>
        </div>

        <div className="clear-both" />
      </div>
    </section>
  );
}
